/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SaveProofRequirementRequest model module.
 * @module model/SaveProofRequirementRequest
 * @version V1
 */
class SaveProofRequirementRequest {
    /**
     * Constructs a new <code>SaveProofRequirementRequest</code>.
     * @alias module:model/SaveProofRequirementRequest
     */
    constructor() { 
        
        SaveProofRequirementRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SaveProofRequirementRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SaveProofRequirementRequest} obj Optional instance to populate.
     * @return {module:model/SaveProofRequirementRequest} The populated <code>SaveProofRequirementRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveProofRequirementRequest();

            if (data.hasOwnProperty('workflowId')) {
                obj['workflowId'] = ApiClient.convertToType(data['workflowId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('stageId')) {
                obj['stageId'] = ApiClient.convertToType(data['stageId'], 'Number');
            }
            if (data.hasOwnProperty('checklistId')) {
                obj['checklistId'] = ApiClient.convertToType(data['checklistId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SaveProofRequirementRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SaveProofRequirementRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}



/**
 * @member {Number} workflowId
 */
SaveProofRequirementRequest.prototype['workflowId'] = undefined;

/**
 * @member {String} name
 */
SaveProofRequirementRequest.prototype['name'] = undefined;

/**
 * @member {Number} stageId
 */
SaveProofRequirementRequest.prototype['stageId'] = undefined;

/**
 * @member {Number} checklistId
 */
SaveProofRequirementRequest.prototype['checklistId'] = undefined;






export default SaveProofRequirementRequest;

